export const INDEX_PATH = '/';
export const SECTIONS_PATH = `/sections`;
export const SECTION_PATH = `${SECTIONS_PATH}/:sectionId`;
export const RESULTS_PATH = '/results';
export const QUESTION_PATH = `${SECTION_PATH}/questions/:questionId`;
export const SIGNUP_PATH = `/signup`;
export const LOGIN_PATH = `/login`;
export const LEARNING_OBJECTIVE_PATH = `${SECTION_PATH}/learning-objective`;
